import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../../axiosinterceptor";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

const getDashboardQueueParam = (state) => {
  const isUncodedView = state.healthInsuranceManager.isUncodedView;
  const isUncodedEnabledEnv =
    process.env.REACT_APP_FLAG_DEV || process.env.REACT_APP_FLAG_COBLH_DEV;

  if (!isUncodedEnabledEnv) return undefined; // other env → key not added at all

  return isUncodedView ? "uncoded" : null; // enabled env → "uncoded" or null
};

export const initialState = {
   isUncodedView: false,
  healthInformationManagerComponentState: {
    selectedRecord: {},
    autoApplyUnassigned: false,
    isEpisodeIdentiferSearchEnabled: false,
  },
  healthInformationManagerEpisodesPayload: {
    separation_date_from: null,
    separation_date_to: null,
    admission_date_from: null,
    admission_date_to: null,
    speciality_ids: [],
    queue_ids: [],
    priority: [],
    status_ids: [],
    coder_ids: [],
    page_number: 1,
    page_size: 10,
    episode_identifier_search: [],
    los: [],
    los_op: "",
    health_fund_contract: [],
    medical_record_number: [],
    drg_code: [],
    sort_by: [],
    sort_order: [],
    is_global_search: false,
  },
  episodeAssignmentPayload: {
    user_id: null,
    hcp_lines: [],
    select_all: false,
    unchecked_ids: [],
    is_flagged: false,
    queue_ids: [],
    user_queue_ids: [],
  },
  healthInformationManagerAssignment: {
    episodeAssignmentLoading: false,
    episodeAssignmentResponse: "",
    episodeAssignmentError: null,
  },
  healthInformationManagerResponse: {
    healthInformationManagerData: [],
    healthInformationManagerLoading: false,
    healthInformationManagerError: null,
  },
  healthInformationManagerEpisodes: {
    loading: false,
    data: [],
    error: null,
  },
  healthInformationManagerDashboards: {
    loading: false,
    data: [],
    error: null,
  },
  assignmentOptions: {
    queues: {
      coder_queue: [],
      auditor_queue: [],
    },
    loading: false,
    has_more: true,
  },
  assignmentUserOptions: {
    users: {
      coders: [],
      auditors: [],
    },
    loading: false,
    has_more: true,
  },
  // Filters
  episodeIdentiferFilterOptions: {
    pageNumber: 0,
    data: [],
    loading: false,
    error: null,
    hasMore: true,
    search: "",
  },
  MRNFilterOptions: {
    pageNumber: 0,
    data: [],
    loading: false,
    error: null,
    hasMore: true,
    search: "",
  },
  specialityFilterOptions: {
    pageNumber: 0,
    data: [],
    loading: false,
    error: null,
    hasMore: true,
    search: "",
  },
  auditorsFilterOptions: {
    pageNumber: 0,
    data: [],
    loading: false,
    error: null,
    hasMore: true,
    search: "",
  },
  queueFilterOptions: {
    pageNumber: 0,
    data: [],
    loading: false,
    error: null,
    hasMore: true,
    search: "",
  },
  coderFilterOptions: {
    pageNumber: 0,
    data: [],
    loading: false,
    error: null,
    hasMore: true,
    search: "",
  },
  priorityFilterOptions: {
    pageNumber: 0,
    data: [],
    loading: false,
    error: null,
    hasMore: true,
    search: "",
  },
  statusFilterOptions: {
    pageNumber: 0,
    data: [],
    loading: false,
    error: null,
    hasMore: true,
    search: "",
  },
  healthFundContractFilterOptions: {
    pageNumber: 0,
    data: [],
    loading: false,
    error: null,
    hasMore: true,
    search: "",
  },
  provisionalDrgFilterOptions: {
    pageNumber: 0,
    data: [],
    loading: false,
    error: null,
    hasMore: true,
    search: "",
  },
  sideBarQueuesData: {
    sideBarQueuesData: [],
    sideBarQueuesDataLoading: false,
    sideBarQueuesDataError: null,
  },
  sideBarUsersData: {
    sideBarCodersData: [],
    sideBarAuditorsData: [],
    sideBarUsersDatapageNumber: 0,
    sideBarUsersDatahasMore: true,
    sideBarUsersDataLoading: false,
    sideBarUsersDataError: null,
  },
};

// episodes
export const getHealthInformationQueueManagerEpisodes = createAsyncThunk(
  "/getHealthInformationQueueManagerEpisodes",
  async ({ storedRole, ...payload }, { fulfillWithValue, rejectWithValue }) => {
  // async ({storedRole, payload}, { fulfillWithValue, rejectWithValue }) => {
    try {
      console.log(storedRole, 'storedRole')
      const response = await axiosInstance.post(
        storedRole  === "coder" ? "/him_workspace_episode_data" : "/him_workspace_auditor_episode_data",
        payload,
      );
      if (response.data) {
        console.log(response, "response");
        return fulfillWithValue(response.data);
      }
      // return data;
    } catch (error) {
      console.error("Error fetching episodes:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
      // throw error;
    }
  },
);

// fetch  Dashboard options

export const getHealthInformationManagerDashboardOptions = createAsyncThunk(
  "/getHealthInformationManagerDashboardOptions",
  async (payload, { getState, fulfillWithValue, rejectWithValue }) => {
    try {
      const queueParam = getDashboardQueueParam(getState());

       const finalPayload = {
        ...payload,
        ...(queueParam !== undefined ? { queue: queueParam } : {}),
      };
      const response = await axiosInstance.post(
        "/him_workspace_cards",
        finalPayload,
      );
      if (response.data) {
        return fulfillWithValue(response.data);
      }
      // return data;
    } catch (error) {
      console.error("Error fetching queues:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
      // throw error;
    }
  },
);

export const getHealthInformationManagerQueuesData = createAsyncThunk(
  "/getHealthInformationManagerQueuesData",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
      const { screen_type } = payload;

    try {
      const response = await axiosInstance.get("/him_workspace_sidebar_queues", {
        params: {
          screen_type
        }
      });
      if (response.data) {
        return fulfillWithValue(response.data);
      }
      // return data;
    } catch (error) {
      console.error("Error fetching episodes:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
      // throw error;
    }
  },
);
export const getHealthInformationManagerUsersData = createAsyncThunk(
  "/getHealthInformationManagerUsersData",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { screen_type, page_number = 1, limit = 10 } = payload;

      const response = await axiosInstance.get("/him_workspace_sidebar_users", {
        params: {
          screen_type,
          page_number,
          limit,
        },
      });

      return fulfillWithValue(response.data);
    } catch (error) {
      console.error("Error fetching users:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);
export const episodeAssignmentCodeWorkflow = createAsyncThunk(
  "/episodeAssignmentCodeWorkflow",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        // "/episode_assignment_code_workflow",
        "/EpisodeAssignmentCodeWorkflow",
        payload,
      );
      if (response.data) {
        return fulfillWithValue(response.data);
      }
    } catch (error) {
      console.error("Error Assigning episodes:", error);
      return rejectWithValue(
        error.response?.data || error.message || "No data found",
      );
    }
  },
);

export const getAssignmentOptions = createAsyncThunk(
  "/getAssignmentOptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    const { queue_type, page_number = 1, limit = 10 } = payload;
    try {
      const res = await axiosInstance.get("/him_get_assign_queues", {
        params: {
          queue_type,
          page_number,
          limit,
        },
      });

      return fulfillWithValue(res.data);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);
export const getAssignmentUserOptions = createAsyncThunk(
  "/getAssignmentUserOptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    const { user_type, page_number = 1, limit = 10,search } = payload;
    try {
      const res = await axiosInstance.get("/him_get_assign_users", {
        params: {
          user_type,
          page_number,
          limit,
          search
        },
      });

      return fulfillWithValue(res.data);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

export const getEpisodeIdentiferFilterOptions = createAsyncThunk(
  "/getEpisodeIdentiferFilterOptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/him_episode_identifier_filters_acs",
        payload,
      );
      if (response.data) {
        return fulfillWithValue(response.data);
      }
      // return data;
    } catch (error) {
      console.error("Error Fetching Episodes Identifer options:", error);
      return rejectWithValue(
        error.response?.data || error.message || "No data found",
      );
      // throw error;
    }
  },
);

export const getMRNFilterOptions = createAsyncThunk(
  "/getMRNFilterOptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/him_mrn_filters_acs",
        payload,
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      console.error("Error fetching MRN Options:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);

export const getSpecialityFilterOptions = createAsyncThunk(
  "/getSpecialityFilterOptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/him_speciality_filter_acs",
        payload,
      );

      return fulfillWithValue(response.data);
    } catch (error) {
      console.error("Error fetching specility options:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);
export const getAuditorsFilterOptions = createAsyncThunk(
  "/getAuditorsFilterOptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/him_auditors_filters_acs",
        payload,
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      console.error("Error fetching specility options:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);

export const getQueueFilterOptions = createAsyncThunk(
  "/getQueueFilterOptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/him_queue_filters_acs",
        payload,
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      console.error("Error fetching queue options:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);

export const getCoderFilterOptions = createAsyncThunk(
  "/getCoderFilterOptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/him_coders_filters_acs",
        payload,
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      console.error("Error fetching users:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);

export const getPriorityFilterOptions = createAsyncThunk(
  "/getPriorityFilterOptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/him_priority_filters_acs",
        payload,
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      console.error("Error fetching priority options:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);

export const getStatusFilterOptions = createAsyncThunk(
  "/getStatusFilterOptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/him_status_filter_acs",
        payload,
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      console.error("Error fetching status options:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);
export const getHealthFundContractFilterOptions = createAsyncThunk(
  "/getHealthFundContractFilterOptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/him_health_fund_get_filters_acs",
        payload,
      );

      return fulfillWithValue(response.data);
    } catch (error) {
      console.error("Error fetching health fund options:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);

export const getProvisionalDrgFilterOptions = createAsyncThunk(
  "/getProvisionalDrgFilterOptions",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/him_drg_filters_acs",
        payload,
      );
      if (response.data) {
        return fulfillWithValue(response.data);
      }
    } catch (error) {
      console.error("Error fetching Provisional Drg Options:", error);
      return rejectWithValue(
        error.response?.data || error.message || "No data found",
      );
    }
  },
);
export const getUncodedEpisodes = createAsyncThunk(
  "/getUncodedEpisodes",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "COBL_Uncoded_Episode_Data",
        payload,
      );
      if (response.data) {
        return fulfillWithValue(response.data);
      }
    } catch (error) {
      console.error("Error fetching uncoded episodes:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message || "No data found",
      );
    }
  },
);
const healthInformationManagerSlicer = createSlice({
  name: "healthInformationManager",
  initialState,
  reducers: {
    updateComponentState: (state, action) => {
      state.healthInformationManagerComponentState.selectedRecord =
        action.payload;
    },
    updateFilters: (state, action) => {
      state.healthInformationManagerEpisodesPayload = {
        ...state.healthInformationManagerEpisodesPayload,
        ...action.payload,
      };
    },
    resetHimFilters: (state) => {
      state.healthInformationManagerEpisodesPayload = {
        separation_date_from: null,
        separation_date_to: null,
        admission_date_from: null,
        admission_date_to: null,
        speciality_ids: [],
        queue_ids: [],
        priority: [],
        status_ids: [],
        coder_ids: [],
        page_number: 1,
        page_size: 10,
        episode_identifier_search: [],
        los: [],
        los_op: "",
        health_fund_contract: [],
        medical_record_number: [],
        drg_code: [],
        sort_by: [],
        sort_order: [],
        is_global_search: false,
      };
    },
    updateAssignmentFilters: (state, action) => {
      state.episodeAssignmentPayload = {
        ...state.episodeAssignmentPayload,
        ...action.payload,
      };
    },
    setAutoApplyUnassigned: (state, action) => {
      state.autoApplyUnassigned = action.payload;
    },
    resetEpisodeAssignmentMessage: (state, action) => {
      state.healthInformationManagerAssignment.episodeAssignmentResponse = "";
    },
    setIsEpisodeIdentiferSearchEnabled(state, action) {
      state.isEpisodeIdentiferSearchEnabled = action.payload;
    },
    setEpisodeIdentiferFilterSearch(state, action) {
      state.episodeIdentiferFilterOptions.search = action.payload;
    },
    setMRNFilterSearch: (state, action) => {
      state.MRNFilterOptions.search = action.payload;
    },
    setSpecialityFilterSearch: (state, action) => {
      state.specialityFilterOptions.search = action.payload;
    },
    setQueueFilterSearch: (state, action) => {
      state.queueFilterOptions.search = action.payload;
    },
    setCoderFilterSearch: (state, action) => {
      state.coderFilterOptions.search = action.payload;
    },
    setAuditorFilterSearch: (state, action) => {
      state.auditorsFilterOptions.search = action.payload;
    },
    setPriorityFilterSearch: (state, action) => {
      state.priorityFilterOptions.search = action.payload;
    },
    setStatusFilterSearch: (state, action) => {
      state.statusFilterOptions.search = action.payload;
    },
    setHealthFundFilterContractSearch(state, action) {
      state.healthFundContractFilterOptions.search = action.payload;
    },
    setProvisionalDrgFilterSearch(state, action) {
      state.provisionalDrgFilterOptions.search = action.payload;
    },
    updateQueuePageNumber: (state, action) => {
      state.queueFilterOptions.pageNumber = action.payload;
    },
    updateCoderPageNumber: (state, action) => {
      state.coderFilterOptions.pageNumber = action.payload;
    },
    // resetProvisionalDrg(state) {
    //   state.provisionalDrgFilterOptions = {
    //     provisionalDrgFilterPageNumber: 0,
    //     provisionalDrgFilterData: [],
    //     provisionalDrgFilterLoading: false,
    //     provisionalDrgFilterError: null,
    //     isprovisionalDrgFilterTrue: true,
    //     provisionalDrgFilterSearch: "",
    //   };
    // },
    // resetEpisodeIdsData(state) {
    //   state.episodeIdentiferFilterOptions = {
    //     episodeIdentiferFilterPageNumber: 0,
    //     episodeIdentiferFilterData: [],
    //     episodeIdentiferFilterLoading: false,
    //     episodeIdentiferFilterError: null,
    //     episodeIdentiferFilterPageTrue: true,
    //     episodeIdentiferFilterSearch: "",
    //   };
    // },
    resetFilterByKey(state, action) {
      const key = action.payload;
      state[key].search = "";
      state[key].data = [];
      state[key].pageNumber = 1;
      state[key].hasMore = true;
      state[key].loading = false;
    },
    setWorkspaceRole: (state, action) => {
      state.healthInformationManagerEpisodesPayload.screen_type =
        action.payload;
    },
    resetSideBarUsersData: (state) => {
      state.sideBarUsersData.sideBarCodersData = [];
      state.sideBarUsersData.sideBarAuditorsData = [];
      state.sideBarUsersData.sideBarUsersDatapageNumber = 0;
      state.sideBarUsersData.sideBarUsersDatahasMore = true;
      state.sideBarUsersData.sideBarUsersDataLoading = false;
      state.sideBarUsersData.sideBarUsersDataError = null;
    },
  setIsUncodedView: (state, action) => {
  state.isUncodedView = action.payload;
    },

  },

  extraReducers: (builder) =>
    builder
      // Episodes
      .addCase(getHealthInformationQueueManagerEpisodes.pending, (state) => {
        state.healthInformationManagerEpisodes.loading = true;
        state.healthInformationManagerEpisodes.error = null;
      })
      .addCase(
        getHealthInformationQueueManagerEpisodes.fulfilled,
        (state, action) => {
          state.healthInformationManagerEpisodes.loading = false;
          state.healthInformationManagerEpisodes.data = action.payload;
        },
      )
      .addCase(
        getHealthInformationQueueManagerEpisodes.rejected,
        (state, action) => {
          state.healthInformationManagerEpisodes.loading = false;
          state.healthInformationManagerEpisodes.error = action.payload;
        },
      )
      // Dashboard options
      .addCase(getHealthInformationManagerDashboardOptions.pending, (state) => {
        state.healthInformationManagerDashboards.loading = true;
        state.healthInformationManagerDashboards.error = null;
      })
      .addCase(
        getHealthInformationManagerDashboardOptions.fulfilled,
        (state, action) => {
          state.healthInformationManagerDashboards.loading = false;
          state.healthInformationManagerDashboards.data = action.payload;
        },
      )
      .addCase(
        getHealthInformationManagerDashboardOptions.rejected,
        (state, action) => {
          state.healthInformationManagerDashboards.loading = false;
          state.healthInformationManagerDashboards.error = action.payload;
        },
      )
      /*sidebar queuesdata*/
      .addCase(getHealthInformationManagerQueuesData.pending, (state) => {
        state.sideBarQueuesData.sideBarQueuesDataLoading = true;
        state.sideBarQueuesData.sideBarQueuesDataError = null;
      })
      .addCase(
        getHealthInformationManagerQueuesData.fulfilled,
        (state, action) => {
          state.sideBarQueuesData.sideBarQueuesDataLoading = false;
          state.sideBarQueuesData.sideBarQueuesData = action.payload;
        },
      )
      .addCase(
        getHealthInformationManagerQueuesData.rejected,
        (state, action) => {
          state.sideBarQueuesData.sideBarQueuesDataLoading = false;
          state.sideBarQueuesData.sideBarQueuesDataError = action.payload;
        },
      )
      .addCase(getHealthInformationManagerUsersData.pending, (state) => {
        state.sideBarUsersData.sideBarUsersDataLoading = true;
      })

      .addCase(
        getHealthInformationManagerUsersData.fulfilled,
        (state, action) => {
          state.sideBarUsersData.sideBarUsersDataLoading = false;

          const page = action.meta.arg.page_number;
          const newCoders = action.payload.users || [];
          const newAuditors = action.payload.auditors || [];

          if (page === 1) {
            state.sideBarUsersData.sideBarCodersData = newCoders;
            state.sideBarUsersData.sideBarAuditorsData = newAuditors;
          } else {
            state.sideBarUsersData.sideBarCodersData = [
              ...state.sideBarUsersData.sideBarCodersData,
              ...newCoders,
            ];

            state.sideBarUsersData.sideBarAuditorsData = [
              ...state.sideBarUsersData.sideBarAuditorsData,
              ...newAuditors,
            ];
          }

          state.sideBarUsersData.sideBarUsersDatapageNumber = page;
          state.sideBarUsersData.sideBarUsersDatahasMore =
            action.payload.has_more ?? false;
        },
      )

      .addCase(
        getHealthInformationManagerUsersData.rejected,
        (state, action) => {
          state.sideBarUsersData.sideBarUsersDataLoading = false;
          state.sideBarUsersData.sideBarUsersDataError = action.payload;
        },
      )
      .addCase(episodeAssignmentCodeWorkflow.pending, (state) => {
        state.healthInformationManagerAssignment.episodeAssignmentLoading = true;
        state.healthInformationManagerAssignment.episodeAssignmentError = null;
      })
      .addCase(episodeAssignmentCodeWorkflow.fulfilled, (state, action) => {
        state.healthInformationManagerAssignment.episodeAssignmentLoading = false;
        state.healthInformationManagerAssignment.episodeAssignmentResponse =
          action.payload;
      })
      .addCase(episodeAssignmentCodeWorkflow.rejected, (state, action) => {
        state.healthInformationManagerAssignment.episodeAssignmentLoading = false;
        state.healthInformationManagerAssignment.episodeAssignmentError =
          action.payload;
        const errorMessage = action.payload?.error;
        console.log("Rejected error", errorMessage);
        // toast.error(errorMessage || "Failed to Assign");
      })
      .addCase(getAssignmentOptions.pending, (state) => {
        state.assignmentOptions.loading = true;
      })
      .addCase(getAssignmentOptions.fulfilled, (state, action) => {
        const page = action.meta.arg.page_number;

        const {
          coder_queue = [],
          auditor_queue = [],
          has_more = false,
        } = action.payload;

        if (page === 1) {
          state.assignmentOptions.queues.coder_queue = coder_queue;
          state.assignmentOptions.queues.auditor_queue = auditor_queue;
        } else {
          state.assignmentOptions.queues.coder_queue = [
            ...state.assignmentOptions.queues.coder_queue,
            ...coder_queue,
          ];

          state.assignmentOptions.queues.auditor_queue = [
            ...state.assignmentOptions.queues.auditor_queue,
            ...auditor_queue,
          ];
        }

        state.assignmentOptions.has_more = has_more;
        state.assignmentOptions.loading = false;
      })
      .addCase(getAssignmentOptions.rejected, (state) => {
        state.assignmentOptions.loading = false;
      })
      .addCase(getAssignmentUserOptions.rejected, (state) => {
        state.assignmentUserOptions.loading = false;
      })
      .addCase(getAssignmentUserOptions.pending, (state) => {
        state.assignmentUserOptions.loading = true;
      })
      .addCase(getAssignmentUserOptions.fulfilled, (state, action) => {
        const page = action.meta.arg.page_number;
        const { coders = [], auditors = [], has_more = false } = action.payload;

        if (page === 1) {
          state.assignmentUserOptions.users.coders = coders;
          state.assignmentUserOptions.users.auditors = auditors;
        } else {
          state.assignmentUserOptions.users.coders = [
            ...state.assignmentUserOptions.users.coders,
            ...coders,
          ];

          state.assignmentUserOptions.users.auditors = [
            ...state.assignmentUserOptions.users.auditors,
            ...auditors,
          ];
        }

        state.assignmentUserOptions.has_more = has_more;
        state.assignmentUserOptions.loading = false;
      })
      // Filters
      .addCase(getEpisodeIdentiferFilterOptions.pending, (state) => {
        state.episodeIdentiferFilterOptions.loading = true;
        state.episodeIdentiferFilterOptions.error = null;
      })
      .addCase(getEpisodeIdentiferFilterOptions.fulfilled, (state, action) => {
        state.episodeIdentiferFilterOptions.loading = false;
        const { episode_identifier_number = [] } = action.payload;
        const page = action.payload.page_number;
        if (page === 1) {
          state.episodeIdentiferFilterOptions.data = episode_identifier_number;
        } else {
          state.episodeIdentiferFilterOptions.data = [
            ...state.episodeIdentiferFilterOptions.data,
            ...(episode_identifier_number || []),
          ];
          // const existingValues = new Set(
          //   state.episodeIdentiferFilterOptions.data.map((item) => item.value),
          // );

          // const uniqueNew = episode_identifier_number.filter(
          //   (item) => !existingValues.has(item.value),
          // );

          // state.episodeIdentiferFilterOptions.data.push(...uniqueNew);
        }
        state.episodeIdentiferFilterOptions.hasMore =
          action.payload?.has_more ?? false;
        state.episodeIdentiferFilterOptions.pageNumber = page;
      })
      .addCase(getEpisodeIdentiferFilterOptions.rejected, (state, action) => {
        state.episodeIdentiferFilterOptions.loading = false;
        state.episodeIdentiferFilterOptions.hasMore = false;
        state.episodeIdentiferFilterOptions.error = action.payload;
      })
      .addCase(getMRNFilterOptions.pending, (state) => {
        state.MRNFilterOptions.loading = true;
        state.MRNFilterOptions.error = null;
      })
      .addCase(getMRNFilterOptions.fulfilled, (state, action) => {
        const newMrns = action.payload?.medical_record_number || [];
        state.MRNFilterOptions.loading = false;
        if (action.payload.page_number === 1) {
          state.MRNFilterOptions.data = newMrns;
        } else {
          state.MRNFilterOptions.data = [
            ...state.MRNFilterOptions.data,
            ...newMrns,
          ];
        }
        state.MRNFilterOptions.hasMore = action.payload?.has_more ?? false;
        state.MRNFilterOptions.pageNumber =
          action.payload?.page_number ?? action.payload.page_number;
      })
      .addCase(getMRNFilterOptions.rejected, (state, action) => {
        state.MRNFilterOptions.loading = false;
        state.MRNFilterOptions.hasMore = false;
        state.MRNFilterOptions.error = action.payload;
      })
      .addCase(getSpecialityFilterOptions.pending, (state) => {
        state.specialityFilterOptions.loading = true;
        state.specialityFilterOptions.error = null;
      })
      .addCase(getSpecialityFilterOptions.fulfilled, (state, action) => {
        state.specialityFilterOptions.loading = false;
        if (action.payload?.page_number === 1) {
          state.specialityFilterOptions.data =
            action.payload?.specialities || [];
        } else {
          state.specialityFilterOptions.data = [
            ...state.specialityFilterOptions.data,
            ...(action.payload?.specialities || []),
          ];
        }
        const isValidPage = action.payload?.has_more ?? false;
        state.specialityFilterOptions.hasMore = isValidPage;
        state.specialityFilterOptions.pageNumber = action.payload?.page_number;
      })
      .addCase(getSpecialityFilterOptions.rejected, (state, action) => {
        state.specialityFilterOptions.loading = false;
        state.specialityFilterOptions.hasMore = false;
        state.specialityFilterOptions.error = action.payload;
      })
      .addCase(getAuditorsFilterOptions.pending, (state) => {
        state.auditorsFilterOptions.loading = true;
        state.auditorsFilterOptions.error = null;
      })
      .addCase(getAuditorsFilterOptions.fulfilled, (state, action) => {
        state.auditorsFilterOptions.loading = false;
        const newUsers = action.payload?.users || [];

        if (action.payload.page_number === 1) {
          state.auditorsFilterOptions.data = newUsers;
        } else {
          state.auditorsFilterOptions.data = [
            ...state.auditorsFilterOptions.data,
            ...newUsers,
          ];
        }

        console.log(
          "Data after append:",
          state.auditorsFilterOptions.data.length,
        );

        const isValidPage = action.payload?.has_more ?? false;
        state.auditorsFilterOptions.hasMore = isValidPage;
        state.auditorsFilterOptions.pageNumber = action.payload.page_number;

        console.log("Updated state:", {
          dataLength: state.auditorsFilterOptions.data.length,
          hasMore: state.auditorsFilterOptions.hasMore,
          pageNumber: state.auditorsFilterOptions.pageNumber,
        });
      })
      .addCase(getAuditorsFilterOptions.rejected, (state, action) => {
        state.auditorsFilterOptions.loading = false;
        state.auditorsFilterOptions.hasMore = false;
        state.auditorsFilterOptions.error = action.payload;
      })
      .addCase(getQueueFilterOptions.pending, (state) => {
        state.queueFilterOptions.loading = true;
        state.queueFilterOptions.error = null;
      })
      .addCase(getQueueFilterOptions.fulfilled, (state, action) => {
        state.queueFilterOptions.loading = false;
        const newQueues = action.payload?.queues?.queues || [];
        if (action.payload.queues.page_number === 1) {
          state.queueFilterOptions.data = newQueues;
        } else {
          state.queueFilterOptions.data = [
            ...state.queueFilterOptions.data,
            ...newQueues,
          ];
        }
        const isValidPage = action.payload?.queues?.has_more ?? false;
        state.queueFilterOptions.hasMore = isValidPage;
        state.queueFilterOptions.pageNumber = action.payload.queues.page_number;
      })
      .addCase(getQueueFilterOptions.rejected, (state, action) => {
        state.queueFilterOptions.loading = false;
        state.queueFilterOptions.hasMore = false;
        state.queueFilterOptions.error = action.payload;
      })
      .addCase(getCoderFilterOptions.pending, (state) => {
        state.coderFilterOptions.loading = true;
        state.coderFilterOptions.error = null;
      })
      .addCase(getCoderFilterOptions.fulfilled, (state, action) => {
        state.coderFilterOptions.loading = false;
        const newUsers = action.payload?.users || [];
        if (action.payload.page_number === 1) {
          state.coderFilterOptions.data = newUsers;
        } else {
          state.coderFilterOptions.data = [
            ...state.coderFilterOptions.data,
            ...newUsers,
          ];
        }
        const isValidPage = action.payload?.has_more ?? false;
        state.coderFilterOptions.hasMore = isValidPage;
        state.coderFilterOptions.pageNumber = action.payload.page_number;
      })
      .addCase(getCoderFilterOptions.rejected, (state, action) => {
        state.coderFilterOptions.loading = false;
        state.coderFilterOptions.hasMore = false;
        state.coderFilterOptions.error = action.payload;
      })
      .addCase(getPriorityFilterOptions.pending, (state) => {
        state.priorityFilterOptions.loading = true;
        state.priorityFilterOptions.error = null;
      })
      .addCase(getPriorityFilterOptions.fulfilled, (state, action) => {
        const options = action.payload;
        state.priorityFilterOptions.loading = false;
        if (options?.page_number === 1) {
          state.priorityFilterOptions.data = action.payload?.priority || [];
        } else {
          state.priorityFilterOptions.data = [
            ...state.priorityFilterOptions.data,
            ...(action.payload?.priority || []),
          ];
        }
        const isValidPage = action.payload?.has_more ?? false;
        state.priorityFilterOptions.hasMore = isValidPage;
        state.priorityFilterOptions.pageNumber = action.payload?.page_number;
      })
      .addCase(getPriorityFilterOptions.rejected, (state, action) => {
        state.priorityFilterOptions.loading = false;
        state.priorityFilterOptions.hasMore = false;
        state.priorityFilterOptions.error = action.payload;
      })
      .addCase(getStatusFilterOptions.pending, (state) => {
        state.statusFilterOptions.loading = true;
        state.statusFilterOptions.error = null;
      })
      .addCase(getStatusFilterOptions.fulfilled, (state, action) => {
        const options = action.payload;
        state.statusFilterOptions.loading = false;
        if (options?.page_number === 1) {
          state.statusFilterOptions.data = action.payload?.status || [];
        } else {
          state.statusFilterOptions.data = [
            ...state.statusFilterOptions.data,
            ...(action.payload?.status || []),
          ];
        }

        const isValidPage = action.payload?.has_more ?? false;
        state.statusFilterOptions.hasMore = isValidPage;
        state.statusFilterOptions.pageNumber = options?.page_number;
      })
      .addCase(getStatusFilterOptions.rejected, (state, action) => {
        state.statusFilterOptions.loading = false;
        state.statusFilterOptions.hasMore = false;
        state.statusFilterOptions.error = action.payload;
      })
      .addCase(getHealthFundContractFilterOptions.pending, (state) => {
        state.healthFundContractFilterOptions.loading = true;
        state.healthFundContractFilterOptions.error = null;
      })
      .addCase(
        getHealthFundContractFilterOptions.fulfilled,
        (state, action) => {
          state.healthFundContractFilterOptions.loading = false;
          const newHealthFunds = action.payload?.health_funds || [];
          if (action.payload.page_number === 1) {
            state.healthFundContractFilterOptions.data = newHealthFunds;
          } else {
            state.healthFundContractFilterOptions.data = [
              ...state.healthFundContractFilterOptions.data,
              ...newHealthFunds,
            ];
          }
          const isValidPage = action.payload?.has_more ?? false;
          state.healthFundContractFilterOptions.hasMore = isValidPage;
          state.healthFundContractFilterOptions.pageNumber =
            action.payload.page_number;
        },
      )
      .addCase(getHealthFundContractFilterOptions.rejected, (state, action) => {
        state.healthFundContractFilterOptions.loading = false;
        state.healthFundContractFilterOptions.hasMore = false;
        state.healthFundContractFilterOptions.error = action.payload;
      })
      .addCase(getProvisionalDrgFilterOptions.pending, (state) => {
        state.provisionalDrgFilterOptions.loading = true;
        state.provisionalDrgFilterOptions.error = null;
      })
      .addCase(getProvisionalDrgFilterOptions.fulfilled, (state, action) => {
        state.provisionalDrgFilterOptions.loading = false;
        const newQueues = action.payload?.drg_codes || [];
        if (action.payload.page_number === 1) {
          state.provisionalDrgFilterOptions.data = newQueues;
        } else {
          state.provisionalDrgFilterOptions.data = [
            ...state.provisionalDrgFilterOptions.data,
            ...newQueues,
          ];
        }
        const isValidPage = action.payload?.has_more ?? false;
        state.provisionalDrgFilterOptions.hasMore = isValidPage;
        state.provisionalDrgFilterOptions.pageNumber =
          action.payload.page_number;
      })
      .addCase(getProvisionalDrgFilterOptions.rejected, (state, action) => {
        state.provisionalDrgFilterOptions.loading = false;
        state.provisionalDrgFilterOptions.error = action.payload;
      })
      .addCase(getUncodedEpisodes.pending, (state) => {
        state.healthInformationManagerEpisodes.loading = true;
        state.healthInformationManagerEpisodes.error = null;
      })
      .addCase(getUncodedEpisodes.fulfilled, (state, action) => {
        state.healthInformationManagerEpisodes.loading = false;
        state.healthInformationManagerEpisodes.data = action.payload;
      })
      .addCase(getUncodedEpisodes.rejected, (state, action) => {
        state.healthInformationManagerEpisodes.loading = false;
        state.healthInformationManagerEpisodes.error = action.payload;
      })
});
export const {
  updateFilters,
  resetHimFilters,
  updateAssignmentFilters,
  updateComponentState,
  resetEpisodeAssignmentMessage,
  setAutoApplyUnassigned,
  setMRNFilterSearch,
  setSpecialityFilterSearch,
  setQueueFilterSearch,
  setCoderFilterSearch,
  setPriorityFilterSearch,
  setStatusFilterSearch,
  updateCoderPageNumber,
  updateQueuePageNumber,
  // updateSpecialityPageNumber,
  // resetProvisionalDrg,
  // resetEpisodeIdsData,
  setProvisionalDrgFilterSearch,
  setHealthFundFilterContractSearch,
  setEpisodeIdentiferFilterSearch,
  resetFilterByKey,
  setWorkspaceRole,
  setAuditorFilterSearch,
  resetSideBarUsersData,
  setIsUncodedView,
} = healthInformationManagerSlicer.actions;

export default healthInformationManagerSlicer.reducer;